import React from 'react';
import { PropTypes } from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import ONBOARDING_TOOLTIP_CLASS_NAME from '../../theme/constants/tooltip';
import { formatMoney } from '../../helpers';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const SummaryCard = ({
  title,
  subtitle,
  isMoney,
  isWarning,
  loading,
  isMobile,
  useTooltip,
  tooltipText,
}) => (
  <Grid
    container
    sx={{
      bgcolor: 'white',
      borderRadius: 2,
      padding: { xs: 0.5, md: 1.5 },
      position: 'relative',
    }}
  >
    {loading ? (
      <Grid item container xs={12}>
        <CircularProgress />
      </Grid>
    ) : (
      <>
        <Grid item xs={12} justifyContent="center">
          <Typography
            variant={isMobile ? 'small_1' : 'small_3'}
            align="center"
            display="block"
            color={isWarning ? 'primary' : ''}
            fontWeight={500}
          >
            {isMoney ? `$${formatMoney(title)}` : title}
          </Typography>
        </Grid>
        <Grid item xs={12} marginTop={0.5} justifyContent="center">
          <Typography
            variant={isMobile ? 'xsmall_3' : 'small_1'}
            align="center"
            display="block"
            color="gray.A500"
            fontWeight={600}
          >
            {subtitle}
          </Typography>
        </Grid>
        {useTooltip && tooltipText && (
          <Tooltip title={tooltipText} placement="top" classes={{ tooltip: ONBOARDING_TOOLTIP_CLASS_NAME }}>
            <InfoIcon
              sx={{
                position: 'absolute',
                top: 4,
                right: 4,
                fontSize: { xs: '14px', md: '16px' },
                cursor: 'pointer',
                zIndex: 1,
              }}
              className={DEFAULT_ICON_CLASS_NAME}
            />
          </Tooltip>
        )}
      </>
    )}
  </Grid>
);

SummaryCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  subtitle: PropTypes.string.isRequired,
  isMoney: PropTypes.bool,
  isWarning: PropTypes.bool,
  loading: PropTypes.bool,
  isMobile: PropTypes.bool,
  useTooltip: PropTypes.bool,
  tooltipText: PropTypes.string,
};

SummaryCard.defaultProps = {
  title: null,
  isMoney: false,
  isWarning: false,
  loading: false,
  isMobile: false,
  useTooltip: false,
  tooltipText: '',
};

export default SummaryCard;
